module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('fill-status-summary', {
    attrs: {
      "title": _vm.$t('pos.campaign.landing-setup'),
      "checked": _vm.readyForCAP,
      "edit": !_vm.readonly
    },
    on: {
      "edit": _vm.showModal
    }
  }, [_c('template', {
    slot: "description"
  }, [(_vm.currentCampaignLandingPage) ? [_vm._v(_vm._s(_vm.$t('pos.campaign.landing-page-is-set')))] : [_vm._v(_vm._s(_vm.$t('pos.campaign.set-landing-page')))]], 2), (_vm.currentCampaignLandingPage) ? _c('template', {
    slot: "icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.currentCampaignLandingPage.link,
      "target": "_blank",
      "rel": "nofollow",
      "title": "currentCampaignLandingPage.link"
    }
  }, [_vm._v(_vm._s(_vm.userInterfaceLink))])]) : _vm._e()], 2), _c('b-modal', {
    ref: "landingPageModal",
    staticClass: "landingpage-modal",
    attrs: {
      "size": "lg",
      "title": _vm.$t('pos.campaign.edit-landing-page'),
      "fade": false,
      "closeTitle": _vm.$t('pos.buttons.close')
    },
    on: {
      "ok": _vm.saveLandingPage
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.availableLandingPageTypes
    },
    on: {
      "change": _vm.changeInternalLandingPageType
    },
    model: {
      value: (_vm.internalLandingPageType),
      callback: function($$v) {
        _vm.internalLandingPageType = $$v
      },
      expression: "internalLandingPageType"
    }
  }), _c('b-form-select', {
    staticClass: "mt-3",
    attrs: {
      "options": _vm.availableLandingPages
    },
    model: {
      value: (_vm.internalSelected),
      callback: function($$v) {
        _vm.internalSelected = $$v
      },
      expression: "internalSelected"
    }
  }), (_vm.internalSelected === _vm.ADD_CUSTOM_LANDING) ? _c('b-form-input', {
    staticClass: "mt-3",
    attrs: {
      "placeholder": _vm.$t('pos.campaign.enter-custom-landing-page')
    },
    model: {
      value: (_vm.internalCustomPageLink),
      callback: function($$v) {
        _vm.internalCustomPageLink = $$v
      },
      expression: "internalCustomPageLink"
    }
  }) : _vm._e(), _c('template', {
    slot: "modal-footer"
  }, [_c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "disabled": !_vm.canSaveLandingPage,
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveLandingPage
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.buttons.save')))]), _c('gotu-nav-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.cancel')))])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea22f5ea"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/landing-page/LandingPage.vue
// module id = 2098
// module chunks = 1